import i18n from '../i18n'
import { MenuDataEnum } from '@/types/enums'

export function fetchMenuData (): any {

  const menuData = {
    'id': '0',
    'children': [
      {
        'id': 'esoft1',
        'text': i18n.t('menu.sidebar'),
        'category': 'Sidebar',
        'icon': 'dashboard',
        'route': '/'
      },
      {
        'id': 'esoft10',
        'text': i18n.t('menu.cockpit'),
        'category': 'Sidebar',
        'icon': 'mdi-speedometer',
        'route': '/cockpit'
      },
      {
        'id': 'esoft2',
        'text': i18n.t('menu.masterData'),
        'category': 'Sidebar',
        'icon': 'dns',
        'children': [
          {
            'id': 'esoft2.1',
            'text': i18n.t('menu.company'),
            'category': MenuDataEnum.CompanyData,
            'icon': 'business',
            'config': {
              'type': 'dataList',
              'showIcon': true
            },
            'children': []
          },
          {
            'id': 'esoft2.6',
            'text': i18n.t('menu.addresses'),
            'category': MenuDataEnum.AddressGroup,
            'icon': 'home',
            'config': {
              'type': 'dataList',
              'showIcon': true
            },
            'children': []
          },
          {
            'id': 'esoft2.8',
            'text': i18n.t('menu.commissions'),
            'category': MenuDataEnum.CommissionGroup,
            'icon': 'mdi-ballot-recount-outline',
            'config': {
              'type': 'dataList',
              'showIcon': true
            },
            'children': []
          },
          {
            'id': 'esoft2.7',
            'text': i18n.t('menu.products'),
            'category': MenuDataEnum.ProductGroup,
            'icon': 'mdi-package-variant-closed',
            'config': {
              'type': 'dataList',
              'showIcon': true
            },
            'children': []
          },
          {
            'id': 'esoft2.2',
            'text': i18n.t('menu.planningData'),
            'category': MenuDataEnum.PlanningData,
            'icon': 'event',
            'children': [
              {
                'id': 'esoft22',
                'text': i18n.t('masterData.masterDataTimeModelsPage.simpleWeekModel'),
                'category': MenuDataEnum.Simple,
                'icon': 'event',
                'route': '/simple-time-model',
                'children': []
              },
              {
                'id': 'esoft23',
                'text': i18n.t('masterData.masterDataTimeModelsPage.dayPlan'),
                'category': MenuDataEnum.Industrial,
                'icon': 'event',
                'route': '/industrial-time-model',
                'children': []
              },
              {
                'id': 'esoft24',
                'text': i18n.t('masterData.masterDataTimeModelsPage.weekPlan'),
                'category': MenuDataEnum.Industrial,
                'icon': 'event',
                'route': '/industrial-time-model',
                'children': []
              },
              {
                'id': 'esoft25',
                'text': i18n.t('masterData.masterDataTimeModelsPage.yearPlan'),
                'category': MenuDataEnum.Industrial,
                'icon': 'event',
                'route': '/industrial-time-model',
                'children': []
              }
            ]
          },
          {
            'id': 'esoft2.3',
            'text': i18n.t('menu.qcq'),
            'category': 'Master Data',
            'icon': 'star',
            'children': [
              {
                'id': 'esoft2.3.1',
                'text': i18n.t('menu.qualification'),
                'category': 'QCQ',
                'icon': 'event',
                'route': '/qcq/qualification',
                'children': []
              },
              {
                'id': 'esoft2.3.2',
                'text': i18n.t('menu.competences'),
                'category': 'QCQ',
                'icon': 'event',
                'route': '/qcq/competence',
                'children': []
              },
              {
                'id': 'esoft2.3.3',
                'text': i18n.t('menu.quality'),
                'category': 'QCQ',
                'icon': 'event',
                'route': '/qcq/quality',
                'children': []
              }
            ]
          },
          {
            'id': 'esoft2.4',
            'text': i18n.t('menu.work'),
            'category': 'Master Data',
            'icon': 'work',
            'route': '/work',
            'children': []
          },
          {
            'id': 'esoft2.5',
            'text': i18n.t('menu.shifts'),
            'category': 'Master Data',
            'icon': 'event_note',
            'route': '/shifts',
            'children': []
          }
        ]
      },
      {
        'id': 'esoft8',
        'text': i18n.t('menu.project'),
        'category': MenuDataEnum.ProjectGroup,
        'icon': 'mdi-ballot-outline',
        'config': {
          'type': 'dataList',
          'showIcon': true
        },
        'children': []
      },
      {
        'id': 'esoft7',
        'text': i18n.t('menu.personalDisposition'),
        'category': 'Disposition',
        'icon': 'mdi-account-convert',
        'children': [
          {
            'id': 'esoft7.1',
            'text': i18n.t('menu.allocation'),
            'category': 'Disposition',
            'icon': 'mdi-account-search',
            'route': '/disposition/allocation'
          },
          {
            'id': 'esoft7.2',
            'text': i18n.t('menu.substitution'),
            'category': 'Disposition',
            'icon': 'mdi-account-switch-outline',
            'route': '/disposition/substitution'
          },
          {
            'id': 'esoft7.3',
            'text': i18n.t('menu.reAllocation'),
            'category': 'Disposition',
            'icon': 'mdi-account-plus',
            'route': '/disposition/re-allocation'
          },
        ]
      },
      {
        'id': 'esoft11',
        'text': i18n.t('menu.recruiting'),
        'category': 'Sidebar',
        'icon': 'mdi-account-multiple-plus',
        'route': '/recruiting',
        'children': []
      },
      {
        'id': 'esoft3',
        'text': i18n.t('menu.absences'),
        'category': 'Sidebar',
        'icon': 'airplanemode_active',
        'route': '/absences',
        'children': []
      },
      {
        'id': 'esoft4',
        'text': i18n.t('menu.planning'),
        'category': 'Sidebar',
        'icon': 'event_available',
        'route': '/planning',
        'children': []
      },
      {
        'id': 'esoft5',
        'text': i18n.t('menu.reporting'),
        'category': 'Sidebar',
        'icon': 'insert_chart',
        'route': '/reporting',
        'children': []
      },
      {
        'id': 'esoft9',
        'text': i18n.t('menu.tools'),
        'category': MenuDataEnum.ToolsGroup,
        'icon': 'mdi-tools',
        'config': {
          'type': 'dataList',
          'showIcon': true
        },
        'children': []
      },
      {
        'id': 'esoft12',
        'text': i18n.t('menu.ticketing'),
        'category': MenuDataEnum.TicketingGroup,
        'icon': 'mdi-lifebuoy',
        'config': {
          'type': 'dataList',
          'showIcon': true
        },
        'children': []
      },
      {
        'id': 'esoft6',
        'text': i18n.t('menu.settings'),
        'category': 'Sidebar',
        'icon': 'settings',
        'children': [
          {
            'id': 'esoft6.1',
            'text': i18n.t('menu.configuration'),
            'category': MenuDataEnum.Configuration,
            'icon': 'settings',
            'config': {
              'type': 'dataList',
              'showIcon': true
            },
            'children': []
          },
          /*{
            'id': 'esoft6.1',
            'text': i18n.t('menu.configuration'),
            'category': 'Settings',
            'icon': 'settings',
            'route': '/settings/configuration'
          },*/
          {
            'id': 'esoft6.2',
            'text': i18n.t('menu.schedulingSettings'),
            'category': 'Settings',
            'icon': 'calendar_today',
            'children': [
              {
                'id': 'esoft6.2.1',
                'text': i18n.t('menu.calendarEvent'),
                'category': MenuDataEnum.CompanyDataSettings,
                'icon': 'calendar_today',
                'config': {
                  'type': 'dataList',
                  'showIcon': true
                },
                'children': []
              },
              {
                'id': 'esoft6.2.2',
                'text': i18n.t('menu.planningGroups'),
                'category': MenuDataEnum.ProfitCenterSettingsWithDepartment,
                'icon': 'event_available',
                'config': {
                  'type': 'dataList',
                  'showIcon': true
                },
                'children': []
              },
            ]
          },
          {
            'id': 'esoft6.3',
            'text': i18n.t('menu.keyBidings'),
            'category': 'Settings',
            'icon': 'keyboard',
            'route': '/settings/keybindings'
          },
          {
            'id': 'esoft6.4',
            'text': i18n.t('menu.security'),
            'category': 'Settings',
            'icon': 'security',
            'children': [
              {
                'id': 'esoft6.4.1',
                'text': i18n.t('menu.registeredEmployees'),
                'category': 'Settings',
                'icon': 'security',
                'route': '/settings/registered-employees'
              },
              {
                'id': 'esoft6.4.2',
                'text': i18n.t('menu.employeeSecurity'),
                'category': 'Settings',
                'icon': 'security',
                'route': '/settings/employee-security'
              }
            ]
          },
          {
            'id': 'esoft6.5',
            'text': i18n.t('menu.companySettings'),
            'category': 'Settings',
            'icon': 'settings',
            'children': [
              {
                'id': 'esoft6.5.1',
                'text': i18n.t('menu.webSettings'),
                'category': 'Settings',
                'icon': 'settings',
                'route': '/settings/company-settings'
              },
              {
                'id': 'esoft6.5.2',
                'text': i18n.t('menu.employeeHierarchy'),
                'category': MenuDataEnum.EmployeeHierarchySettings,
                'icon': 'settings',
                'config': {
                  'type': 'dataList',
                  'showIcon': true
                },
                'children': []
              },
              {
                'id': 'esoft6.5.3',
                'text': i18n.t('menu.profitCenterAdditionalFields'),
                'category': MenuDataEnum.ProfitCenterAdditionalFieldsSettings,
                'icon': 'settings',
                'config': {
                  'type': 'dataList',
                  'showIcon': true
                },
                'children': []
              }
            ]
          },
          {
            'id': 'esoft6.6',
            'text': i18n.t('menu.email'),
            'category': 'Settings',
            'icon': 'email',
            'children': [
              {
                'id': 'esoft6.6.1',
                'text': i18n.t('menu.smtpSettings'),
                'category': 'Settings',
                'icon': 'settings',
                'route': '/settings/email-smtp-settings'
              },
              {
                'id': 'esoft6.6.2',
                'text': i18n.t('menu.emailDefaultText'),
                'category': 'Settings',
                'icon': 'settings',
                'route': '/settings/email-default-text'
              }
            ]
          }
        ]
      }
    ]
  }
  return menuData
}
